import { Injectable } from '@angular/core';
import { Observable, Subject } from "rxjs";
import { Router } from "@angular/router";
import { TokenStorageService } from "./token.storage.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "../../environments/environment";
import {LoginInfo} from '../model/login';

const headers = new HttpHeaders({
  'Content-Type': 'application/json'
});

@Injectable({
  providedIn: 'root'
})
export class LoginService {
  private subject = new Subject<LoginInfo | undefined>();

  constructor(
    private httpClient: HttpClient,
    private tokenStorageService: TokenStorageService,
    private router: Router
  ) {}

  login(login: string, password: string): Observable<LoginInfo> {
    return this.httpClient.post<LoginInfo>(environment.apiUrl + '/authentication/login',
      { login: login, password: password },
      { headers }
    );
  }

  get(): Observable<LoginInfo | undefined> {
    return this.subject.asObservable();
  }

  update(): void {
    this.subject.next(this.tokenStorageService?.getLoginInfo());
  }

  logout(): void {
    this.tokenStorageService.logout();
    this.update();
    setTimeout(() =>
      this.router.navigate(['/']).then(() => {
        window.location.reload();
      }), 500);
  }

  isLoggedIn(): boolean {
    return !!this.tokenStorageService.getToken();
  }

  getToken(): string | undefined {
    return this.tokenStorageService.getToken();
  }
}
